import React from "react";
import { Helmet } from "react-helmet-async";
import { useAuth0 } from "@auth0/auth0-react";

/**
 * Temporary holding page shown to everyone who is not an admin while the site
 * is walled off. Signed-in non-admins get a sign-out control; anonymous
 * visitors get no login affordance at all.
 */
const ComingSoon = () => {
  const { isAuthenticated, logout } = useAuth0();

  const handleLogout = () => {
    const returnUrl = process.env.REACT_APP_BASE_URL || window.location.origin;
    logout({ logoutParams: { returnTo: returnUrl } });
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-light-grey px-4 py-12">
      <Helmet>
        <title>Coming Soon | DayShift Sports MMA</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="w-full max-w-lg text-center">
        <img
          src="/ds-alternate.png"
          alt="DayShift Sports MMA"
          width={512}
          height={512}
          className="mx-auto w-44 h-44 sm:w-56 sm:h-56 object-contain"
        />

        <div className="bg-white rounded-xl shadow-card mt-10 px-8 py-12">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-deep-red">
            Coming Soon
          </p>
          <h1 className="mt-4 text-3xl font-bold text-dark-grey">
            We&apos;re putting on the finishing touches
          </h1>
          <p className="mt-4 text-medium-grey">
            Fantasy MMA leagues, live scoring, and global competition are almost
            ready. Check back shortly.
          </p>

          {isAuthenticated && (
            <button
              onClick={handleLogout}
              className="mt-8 text-sm font-medium text-medium-grey hover:text-deep-red transition-colors"
            >
              Sign out
            </button>
          )}
        </div>

        <p className="mt-6 text-xs text-medium-grey">
          &copy; {new Date().getFullYear()} DayShift Sports. All rights
          reserved.
        </p>
      </div>
    </div>
  );
};

export default ComingSoon;
